import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#2c398f";
function DNT({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M18.806 14.325c.395-.02.772-.172 1.07-.432-.414 2.111-1.57 4.19-3.551 5.332-1.517.883-3.413 1.177-5.256.952-.276-.796-1-1.644-2.258-2.285-1.982-1.021-2.913-2.787-3.757-1.922a.9.9 0 00-.19.26 3 3 0 01-.104-.243C3.14 11.97 4.76 7.935 8 5.044c1.93-1.715 4.188-1.524 6.205-.589a1.02 1.02 0 00-.38.814V9.32a4.076 4.076 0 00-5.207.944 4.12 4.12 0 00.078 5.316 4.076 4.076 0 005.233.788 1.049 1.049 0 002-.45V5.477c1.55 1.09 2.791 2.475 3.36 3.428.277.478.475.999.586 1.541-.244-.18-.528-.3-.827-.346-.638-.035-1.12.832-.793 2.077.276 1.127-.069 2.114.551 2.148m-7.772.07c-2.172-1.247-.345-4.45 1.827-3.204.655.364.724 1.524.603 2.268-.224 1.282-1.43 1.507-2.43.935m1.017-8.278c-.483.017-.827.606-.81.866s.379.416.878.243c.449-.156.863-.053.845-.312-.017-.26-.448-.814-.913-.797" /></Svg>;
}
DNT.DefaultColor = DefaultColor;
export default DNT;